import styled from '@emotion/styled'

export const Item = styled.div`
  display: grid;
  grid-template-columns: 200px auto 120px;
`
